/** Shared close (×) button for every modal — positioned by .modal-close. */
export default function ModalCloseButton({ onClick, label = 'Close' }) {
  return (
    <button type="button" onClick={onClick} className="modal-close" aria-label={label}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  );
}
